import { Text } from "@mantine/core";

import type { SalesMetricsView } from "../data/types";

import styles from "./cardContent.module.css";
import { MetricCard } from "./MetricCard";
import { computeDirectProgress, computeMetricStatus, computeMetricTone } from "./targetProgress";
import { SALES_TARGET } from "./targets";

interface Props {
    view: SalesMetricsView;
    onClick?: () => void;
}

export function SalesCard({ view, onClick }: Props) {
    const sales = view.sales;
    const hasSales = sales !== null;
    const progress = hasSales ? computeDirectProgress(sales, SALES_TARGET) : 0;
    const targetUnit = SALES_TARGET === 1 ? "sale" : "sales";
    const status = hasSales ? computeMetricStatus(progress) : undefined;
    const tone = hasSales ? computeMetricTone(progress) : undefined;
    return (
        <MetricCard
            title="Net sales"
            isLoading={view.isLoading}
            isEmpty={!hasSales}
            emptyValue="No recent sales data."
            value={
                <Text component="span" className={styles.bigNumber}>
                    {sales}
                </Text>
            }
            footer={
                <>
                    {SALES_TARGET} {targetUnit}
                </>
            }
            status={status}
            tone={tone}
            onClick={onClick}
        />
    );
}
